<template>
<div>
    <zm-checkbox v-model="showFailedOnly" v-if="success">showFailedOnly</zm-checkbox>
    <zm-table @selection-change="handleSelect"
    :data="tableData.slice((pageable.pageNumber - 1) * pageable.pageSize, pageable.pageNumber * pageable.pageSize)">
        <zm-table-column type="selection" width="55" :selectable="isSelectable"></zm-table-column>
        <zm-table-column label="secretFullPath" prop="secretFullPath"></zm-table-column>
        <zm-table-column label="errorMessage" prop="errorMessage" v-if="!success"></zm-table-column>
        <zm-table-column label="SourceType" prop="sourceShareType" v-if="success && (action === 'UpdateSecretToShare' || action === 'UpdateSecretToReference')"></zm-table-column>
        <zm-table-column label="TargetType" prop="targetShareType" v-if="success && (action === 'UpdateSecretToShare' || action === 'UpdateSecretToReference')"></zm-table-column>
        <!-- <zm-table-column label="CreateIfNotExist" prop="createIfNotExists" v-if="success && (action === 'UpdateSecretToShare' || action === 'UpdateSecretToReference')">
            <template slot-scope="scope">
                <i :class="scope.row.createIfNotExists ? 'zm-icon-ok' : 'zm-icon-close'"></i>
            </template>
        </zm-table-column> -->
        <zm-table-column label="TargetVersionStage" prop="targetVersionStage" v-if="success && action === 'RevokeVersion'"></zm-table-column>
        <zm-table-column label="AssignToApplicationList" prop="assignToApplicationList" v-if="success && action === 'UpdateSecretToShare'"></zm-table-column>
        <zm-table-column label="FullPathFromReferencedSecret" prop="fullPathFromReferencedSecret" v-if="success && action === 'UpdateSecretToReference'"></zm-table-column>
        <zm-table-column v-if="success">
            <!-- eslint-disable-next-line -->
            <template slot="header" slot-scope="scope">
                <zm-button type="text" @click="confirmSend(null, true)" v-if="selectLines.length">save selected</zm-button>
            </template>
            <template slot-scope="scope">
                <i v-if="scope.row.hasSuccess" class="zm-icon-ok"></i>
                <zm-button type="text" @click="confirmSend(scope.row, false)" :loading="scope.row.loading"
                    v-if="!scope.row.hasSuccess">save</zm-button>
                <zm-tooltip style="color: #8492a6; font-size: 13px;" class="item"
                    :content="scope.row.errorMsg" placement="left"
                    v-if="!scope.row.hasSuccess && scope.row.errorMsg">
                    <i class="zm-icon-help-outline"></i>
                </zm-tooltip>
            </template>
        </zm-table-column>
    </zm-table>
    <div style="text-align: center" class="pagination-wrap">
        <zm-pagination @size-change="handleSizeChange"
            :current-page.sync="pageable.pageNumber"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageable.pageSize"
            layout="sizes, total, prev, pager, next, jumper"
            :total="data.length">
        </zm-pagination>
    </div>
    <zm-dialog title="Confirm Operation" :visible.sync="visible" show-close append-to-body>
        Please repeat action to confirm operation of <em>{{ action }}</em>
        <zm-form label-width="150px">
            <zm-form-item label="repeat action">
                <zm-input v-model.trim="form.repeatAction"></zm-input>
            </zm-form-item>
        </zm-form>
        <div slot="footer" class="dialog-footer">
            <zm-button size="small" @click="visible = false">Close</zm-button>
            <zm-button size="small" type="primary" @click="doSend">Submit</zm-button>
        </div>
    </zm-dialog>
</div>
</template>
<script>
import { addVersion, updateToCurrent, revokeVersion } from '@/api/version'
import { createSecret } from '@/api/index'
export default {
    name: 'updateResult',
    props: ['result', 'action'],
    data () {
        return {
            data: [],
            success: false,
            pageable: {
                pageSize: 10,
                pageNumber: 1
            },
            showFailedOnly: false,
            selectLines: [],
            visible: false,
            form: {
                repeatAction: '',
                isBatch: false,
                row: null
            },
            uploadingCount: 0,
            uploadingIndex: 0
        }
    },
    watch: {
        uploadingCount () {
            if (!this.uploadingCount) {
                this.uploadingIndex++
                this.myUpload()
            }
        },
        'result.success' () {
            this.initData()
        },
        'action' () {
            this.initData()
        },
        'result.data' () {
            this.initData()
        }
    },
    computed: {
        tableData () {
            if (this.showFailedOnly) {
                return this.data.filter(data => {
                    return !data.hasSuccess
                })
            }
            return this.data
        }
    },
    created () {
        this.initData()
    },
    methods: {
        isSelectable (row, index) {
            return !row.hasSuccess
        },
        initData () {
            this.data = []
            this.pageable.pageSize = 10
            this.pageable.pageNumber = 1
            if (this.result.data) {
            this.result.data.map(item => {
                this.data.push({
                    loading: false,
                    hasSuccess: false,
                    secretFullPath: item.secretFullPath,
                    errorMessage: item.errorMessage,
                    sourceShareType: item.sourceShareType,
                    targetShareType: item.targetShareType,
                    createIfNotExists: item.createIfNotExists,
                    targetVersionStage: item.targetVersionStage,
                    assignToApplicationList: item.assignToApplicationList,
                    fullPathFromReferencedSecret: item.fullPathFromReferencedSecret,
                    requestEntity: item.requestEntity,
                    errorMsg: ''
                })
            })
            }
            this.success = this.result.success
        },
        async sendUpdateResult (row, isBatch) {
            const formData = new FormData()
            Object.keys(row.requestEntity).map(item => {
                if (row.requestEntity[item] !== null) {
                    formData.append(item, row.requestEntity[item])
                }
            })
            if (this.action === 'UpdateSecretToShare' || this.action === 'UpdateSecretToReference') {
                row.loading = true
                if (isBatch) {
                    this.uploadingCount++
                }
                createSecret(formData).then(response => {
                    row.hasSuccess = true
                    row.loading = false
                    if (isBatch) {
                        this.uploadingCount--
                    }
                }).catch(err => {
                    row.errorMsg = err.response.data.errorMessage
                    row.loading = false
                    if (isBatch) {
                        this.uploadingCount--
                    }
                })
            } else if (this.action === 'UpdateVersionToCurrent') {
                row.loading = true
                if (isBatch) {
                    this.uploadingCount++
                }
                updateToCurrent(formData).then(response => {
                    console.log(response)
                    row.hasSuccess = true
                    row.loading = false
                    if (isBatch) {
                        this.uploadingCount--
                    }
                }).catch(err => {
                    row.errorMsg = err.response.data.errorMessage
                    row.loading = false
                    if (isBatch) {
                        this.uploadingCount--
                    }
                })
            } else if (this.action === 'RevokeVersion') {
                row.loading = true
                if (isBatch) {
                    this.uploadingCount++
                }
                revokeVersion(formData).then(response => {
                    console.log(response)
                    row.hasSuccess = true
                    row.loading = false
                    if (isBatch) {
                        this.uploadingCount--
                    }
                }).catch(err => {
                    row.errorMsg = err.response.data.errorMessage
                    row.loading = false
                    if (isBatch) {
                        this.uploadingCount--
                    }
                })
            } else if (this.action === 'AddNewVersion') {
                row.loading = true
                if (isBatch) {
                    this.uploadingCount++
                }
                addVersion(formData).then(response => {
                    console.log(response)
                    row.hasSuccess = true
                    row.loading = false
                    if (isBatch) {
                        this.uploadingCount--
                    }
                }).catch(err => {
                    row.errorMsg = err.response.data.errorMessage
                    row.loading = false
                    if (isBatch) {
                        this.uploadingCount--
                    }
                })
            }
        },
        confirmSend (row, isBatch) {
            this.visible = true
            this.form.repeatAction = ''
            this.form.row = row || null
            this.form.isBatch = isBatch
        },
        async doSend () {
            if (this.form.repeatAction === this.action) {
            this.visible = false
            if (this.form.isBatch) {
                await this.myUpload()
            } else {
                this.sendUpdateResult(this.form.row, false)
            }
            } else {
                this.$message.error('Wrong input, please check')
            }
        },
        async sendUpdateResults (i) {
            for (let j = 0; j < 10; j++) {
                if (i * 10 + j < this.selectLines.length) {
                    console.log(i, j)
                    this.sendUpdateResult(this.selectLines[i * 10 + j], true)
                }
            }
        },
        async myUpload () {
            if (this.selectLines.length) {
                if (this.uploadingIndex < this.selectLines.length / 10) {
                    var that = this
                    new Promise(
                        function () {
                            that.sendUpdateResults(that.uploadingIndex)
                        }
                    ).then(res => {
                        this.uploadingIndex++
                        that.myUpload()
                    })
                } else {
                    this.uploadingCount = 0
                    this.uploadingIndex = 0
                }
            }
        },
        handleSelect (val) {
            if (val.length) {
                this.selectLines = []
                val.map(item => {
                    this.selectLines.push(item)
                })
            }
        },
        handleSizeChange (val) {
            this.pageable.pageSize = val
        }
    }
}
</script>
